import { CacheStorage, QueryBus } from '@skylab-shared/core';
import { v4 as uuid } from 'uuid';
import { PagedCollectionQuery } from './../query/paged-collection-query';
import { ListFilterSettings, ListPaginationSettings, QuickListDataSourceBase } from './quick-list-data-source.service-base';



export class CacheableQuickListDataSourceBase<TQuery extends PagedCollectionQuery<TItem>, TItem> extends QuickListDataSourceBase<TQuery, TItem> {
    private readonly cacheStorage: CacheStorage;

    private cacheStorageUniqueId: string;
    private cacheKeys: string[];
    public constructor(queryBus: QueryBus, cacheStorage: CacheStorage) {
        super(queryBus);

        this.cacheStorage = cacheStorage;

        this.cacheStorageUniqueId = uuid();
        this.cacheKeys = [];
    }

    public override setParamsFunction<T = unknown>(params: (() => T) | null): void {
        super.setParamsFunction(params);
        this.clearCache();
    }

    public override async quickListAsync(pagination: ListPaginationSettings, filter: ListFilterSettings): Promise<TItem[]> {
        if (!filter.pattern) {
            const key = this.buildStorageKey(pagination.pageSize, pagination.pageNumber);
            if (!this.cacheStorage.has(key)) {
                this.cacheKeys.push(key);
                this.cacheStorage.addAsync(key, async () => super.quickListAsync(pagination, filter));
            }
            return await this.cacheStorage.getAsync<TItem[]>(key);
        }
        return await super.quickListAsync(pagination, filter);
    }

    public clearCache(): void {
        this.cacheKeys.forEach(id => this.cacheStorage.remove(id));
        this.cacheKeys = [];
    }

    public override dispose(): void {
        super.dispose();
        this.paramsFunction = null;
        this.clearCache();
    }

    //#region Private methods

    private buildStorageKey(pageSize: number, pageNumber: number): string {
        return `QL#${this.cacheStorageUniqueId}:${pageSize}:${pageNumber}`;
    }

    //#endregion
}
